import { useComments } from 'Presentation/SyncStore';
import { useSelector } from '_common/hooks';
import { richTextToPlainText } from '_common/lib/components';

const useSearchComments = () => {
  const comments = useComments();
  const searchBy = useSelector((state) => state.presentation.comments.searchBy);

  if (!comments) {
    return [];
  }

  const filterComment = (comment: Presentation.Data.Comment, value: string) => {
    if (comment?.content?.content) {
      return richTextToPlainText(comment.content.content)
        .toLowerCase()
        .includes(value.toLowerCase());
    }

    return false;
  };

  if (searchBy) {
    return Object.values(comments.data).filter((comment) => filterComment(comment, searchBy));
  }

  return Object.values(comments.data);
};

export default useSearchComments;
